import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=92a58be0"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=92a58be0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myagent\\_work\\14\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92a58be0')) {
      api.createRecord('92a58be0', component.options)
    } else {
      api.reload('92a58be0', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=92a58be0", function () {
      api.rerender('92a58be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrivacyPolicy.vue"
export default component.exports